import {
  Component,
  ContentChild,
  ContentChildren,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { PrPaginationV2Component } from '../pr-pagination-v2/pr-pagination-v2.component';
import { PrListItemColumnComponent } from './pr-list-item/pr-list-item-column/pr-list-item-column.component';

@Component({
    selector: 'pr-list',
    templateUrl: './pr-list.component.html',
    styleUrls: ['./pr-list.component.scss'],
    standalone: false
})
export class PrListComponent extends PrPaginationV2Component implements OnInit {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() data;
  @Input() pagination: boolean = false;
  @ViewChild('filtersTemplate', { static: false }) filtersTemplate;
  @ContentChildren(PrListItemColumnComponent)
  columns: QueryList<PrListItemColumnComponent>;
  @ContentChild('icon') iconTemplate: TemplateRef<any>;
  @ContentChild('body') bodyTemplate: TemplateRef<any>;
  dataPaginated;
  dataSearched;
  searchValue: string;
  @Input() search: boolean = false;
  @Input() searchProperty = 'name';
  @Input() loading: boolean = false;
  @Input() expandable: boolean = true;
  @Input() redirect: boolean = false;
  @Input() expanded: boolean = false;
  @Input() maxHeaderElems: number = 5;
  @Output() onItemClicked: EventEmitter<any> = new EventEmitter();
  @Input() placeholder = 'Rechercher';
  @Input() onlyRadio: boolean = false;

  constructor() {
    super();
  }

  ngOnInit(): void {}
}
